module.exports = window["markdeep"];